import { getOfficeReviews } from './GetOfficeReviews';
import { getOfficeReviewByShift } from './GetOfficeReviewByShift';
import { deleteOfficeReview } from './DeleteOfficeReview';

/**
 * Office Reviews API Client
 * Provides low-level HTTP calls to organization-service review endpoints
 */
export const OfficeReviewsApi = {
  getOfficeReviews,
  getOfficeReviewByShift,
  deleteOfficeReview,
};
